export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === "/protected") return;

  const { useAuthStore } = await import("~/stores/auth.store");
  const authStore = useAuthStore();

  if (
    to.meta.layout !== "checkout" &&
    to.meta.layout !== "order-confirmation"
  ) {
    authStore.is_guest_checkout = false;
    if (authStore.guest && import.meta.client) {
      const isGuestCheckoutSessionOver =
        from.meta.layout === "order-confirmation" ||
        window.confirm(
          "Weet u zeker dat u het afrekenen wilt annuleren? Uw winkelwagenartikelen gaan definitief verloren."
        );
      /* Since guest trolley is converted during registration, we need to invalidate the trolley because guest checkout session is only persisted during checkout not outside of that */
      if (isGuestCheckoutSessionOver) {
        authStore.guest = null;
        const { useTrolleyStore } = await import("~/stores/trolley.store");
        const trolleyStore = useTrolleyStore();
        trolleyStore.destroyTrolley();
      } else {
        return abortNavigation();
      }
    }
  }

  if (
    to.meta.layout !== "auth" &&
    !authStore.is_authenticated &&
    !authStore.is_guest_checkout
  ) {
    const { useRootStore } = await import("~/stores/root.store");
    const rootStore = useRootStore();
    // indication - user has not taken any positive auth action
    rootStore.after_auth_intended_route = null;
  }
});
